module.exports = __webpack_public_path__ + "img/violet_026.c013c7cb.png";